
<template>
    <form action="/send-app-links" method="POST" @submit.prevent="submit" novalidate>
        <form-input-type-phone-number
            name="phone"
            :label="__('Enter your phone number')"
            :phoneCountry="phoneCountry"
            :errors="errors.phone"
            full-border
        ></form-input-type-phone-number>

        <!-- FIXME: nesedi nemecky preklad -->
        <v-button :label="__('Send link to download the app')" type="submit" full-width></v-button>
    </form>
</template>

<script>
    export default {
        props: {
            phoneCountry: {
                type: String,
                required: true,
                default: 'CS'
            }
        },

        data() {
            return {
                errors: [],
            }
        },

        methods: {
            submit() {      
                let formData = {}

                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })
                
                axios
                    .post('/send-app-links', formData)
                    .then(async ({ data }) => {
                        $(this.$el).find(".v-btn").html('<span class="v-btn--label">'+lang.get("Sent")+'</span><svg aria-hidden="true" focusable="false" width="20px" data-prefix="fas" data-icon="check" class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#fff" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>')
                        $(this.$el).find(".v-btn").addClass('pointer-disabled')
                        this.errors = []
                        window.dataLayer.push({
                            'event': 'app_download_intent',
                            'download_method': 'sms'
                        })
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>
